module.exports = __webpack_public_path__ + "141675047149a28b99ba7975234d03e1.jpg";